module.exports = new __parcel__URL__("processengineering.c1c43e47.png").toString();